import type {ProForm} from './types';

export const INITIAL_PRO_FORM: ProForm = {
  coverage: 0,
  polygonIds: [],
  selectedPolygons: {},
  date: {
    start: null,
    end: null
  }
};
